import { mapEnumToOptions } from '@abp/ng.core';

export enum MediaFileStorageType {
  BackBlaze = 'BackBlaze',
  BunnyStream = 'BunnyStream',
}

export const mediaFileStorageTypeOptions = mapEnumToOptions(MediaFileStorageType);
